const RegistrationType = Object.freeze({
  COMPANY: "company",
  USER: "user",
});

/** @type {import("./types").PreferredContactMethod} */
const PreferredContactMethod = Object.freeze({
  EMAIL: "Email",
  PHONE: "Phone",
});

/** @type {import("./types").QuestionType} */
const QuestionType = Object.freeze({
  TEXTBOX: "textbox",
  RATING_SCALE: "rating",
  MATRIX: "table-sheet",
  SINGLE_RESPONSE: "single-select",
  MULTIPLE_RESPONSE: "multiple",
});

const CODE_KEY = {
  year_of_birth: "year_of_birth",
  feel_about_financial_health: "feel_about_financial_health",
  has_homeownership: "has_homeownership",
  use_robo_advisor: "use_robo_advisor",
  has_advisor: "has_advisor",
  financial_plan: "financial_plan",
  has_registered_accounts: "has_registered_accounts",
  hh_assets: "hh_assets",
  primary_res_mort: "primary_res_mort",
  cons_debt: "cons_debt",
  hh_income: "hh_income",
  marital_status: "marital_status",
  has_children_in_home: "has_children_in_home",
};

/** @type {import("./types").AnswerRequired} */
const AnswerRequired = Object.freeze({
  REQUIRED: "required",
  NOT_REQUIRED_NO_SKIP: "not_required_no_skip",
  NOT_REQUIRED_ALLOW_SKIP: "not_required_allow_skip"
});

/** @type {import("./types").FontType} */
const FontType = Object.freeze({
  SANS_SERIF: "sans-serif",
  SERIF: "serif",
  MONOSPACE: "monospace",
});

/** @type {import("./types").FontSource} */
const FontSource = Object.freeze({
  NONE: "none",
  FILE: "file",
  "GOOGLE_FONT": "googlefont",
});

const SURVEY_RESULTS_COOKIE_NAME = "fhc_survey_result";
const EMBEDDED_SURVEY_RESULTS_COOKIE_NAME = "embedded_fhc_survey_result";

const MIN_RATING_CHOICES = 4;
const MAX_RATING_CHOICES = 10;

export {
  RegistrationType,
  PreferredContactMethod,
  QuestionType,
  AnswerRequired,
  FontType,
  FontSource,
  CODE_KEY,
  SURVEY_RESULTS_COOKIE_NAME,
  EMBEDDED_SURVEY_RESULTS_COOKIE_NAME,
  MIN_RATING_CHOICES,
  MAX_RATING_CHOICES,
};
